export const MIN_SELECTION = 3;
export const MAX_SELECTION = 200;
export const DEFAULT_NUM_ROWS = 10;
